var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"word-view_frame",attrs:{"src":_vm.frameSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }